import React from 'react';
import Icon from '../../../components/AppIcon';

const SocialMediaStats = ({ platforms }) => {
  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000)?.toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000)?.toFixed(1) + 'K';
    }
    return num?.toString();
  };

  const getPlatformIcon = (platform) => {
    switch (platform?.toLowerCase()) {
      case 'instagram':
        return 'Instagram';
      case 'youtube':
        return 'Youtube';
      case 'tiktok':
        return 'Music';
      case 'twitter':
        return 'Twitter';
      default:
        return 'Globe';
    }
  };

  const getPlatformColor = (platform) => {
    switch (platform?.toLowerCase()) {
      case 'instagram':
        return 'bg-pink-500/10 text-pink-500';
      case 'youtube':
        return 'bg-red-500/10 text-red-500';
      case 'tiktok':
        return 'bg-purple-500/10 text-purple-500';
      case 'twitter':
        return 'bg-blue-500/10 text-blue-500';
      default:
        return 'bg-primary/10 text-primary';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-foreground">Sosyal Medya İstatistikleri</h2>
        <button className="text-sm text-primary hover:text-primary/80 transition-smooth flex items-center gap-1">
          <Icon name="RefreshCw" size={16} />
          <span>Güncelle</span>
        </button>
      </div>
      <div className="space-y-4">
        {platforms?.map((platform, index) => (
          <div key={index} className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${getPlatformColor(platform?.name)}`}>
                  <Icon name={getPlatformIcon(platform?.name)} size={20} />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground">{platform?.name}</h3>
                  <p className="text-xs text-muted-foreground">@{platform?.username}</p>
                </div>
              </div>
              {platform?.verified && (
                <div className="flex items-center gap-1 px-2 py-1 bg-success/10 rounded-full">
                  <Icon name="CheckCircle" size={14} color="var(--color-success)" />
                  <span className="text-xs font-medium text-success">Doğrulandı</span>
                </div>
              )}
            </div>

            <div className="grid grid-cols-3 gap-4">
              <div>
                <p className="text-xs text-muted-foreground mb-1">Takipçi</p>
                <p className="text-lg font-bold text-foreground">{formatNumber(platform?.followers)}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Etkileşim</p>
                <p className="text-lg font-bold text-foreground">{platform?.engagement}%</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Erişim</p>
                <p className="text-lg font-bold text-foreground">{formatNumber(platform?.reach)}</p>
              </div>
            </div>

            <div className="mt-3 pt-3 border-t border-border">
              <div className="flex items-center justify-between text-xs">
                <span className="text-muted-foreground">Son güncelleme</span>
                <span className="text-foreground font-medium">{platform?.lastUpdated}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialMediaStats;